import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0327fd32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "correlation-analysis" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content-left" }
const _hoisted_4 = { class: "content-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OperateHeader = _resolveComponent("OperateHeader")!
  const _component_AnalysisChart = _resolveComponent("AnalysisChart")!
  const _component_RadarChart = _resolveComponent("RadarChart")!
  const _component_RoseChart = _resolveComponent("RoseChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_OperateHeader, {
      onTypeChange: _ctx.typeChange,
      onSearchData: _ctx.searchData
    }, null, 8, ["onTypeChange", "onSearchData"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AnalysisChart, {
          airType: _ctx.airType,
          standardDataList: _ctx.standardDataList,
          isOverSeven: _ctx.isOverSeven
        }, null, 8, ["airType", "standardDataList", "isOverSeven"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_RadarChart, {
          airType: _ctx.airType,
          radarDataList: _ctx.radarDataList
        }, null, 8, ["airType", "radarDataList"]),
        _createVNode(_component_RoseChart, {
          airType: _ctx.airType,
          roseDataList: _ctx.roseDataList
        }, null, 8, ["airType", "roseDataList"])
      ])
    ])
  ]))
}